import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import ChangePasswordContent from '../components/ChangePasswordContent';

export default function ChangePassword() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="tercih-ayarlari" />
                    <ChangePasswordContent />
                </div>
            </div>
        </div>
    );
}
